var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('WsReadSection',{attrs:{"id":_vm._id,"modelName":_vm.modelName,"label":_vm.label,"fields":_vm.fields,"leftFields":_vm.leftFields,"rightFields":_vm.rightFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }